/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllExamInvInqLookups = require('../../common/services/GetAllExamInvInqLookups');
var GetExamInvInqReferralById = require('../../common/services/GetExamInvInqReferralById');
var SecExamInvInqReferralEditView = require('../../common/views/SecExamInvInqReferralEditView');
var GetExamIdentifiers = require('../services/GetExamIdentifiers');

module.exports = function(examId, referralId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetAllExamInvInqLookups(), GetExamIdentifiers(examId), GetExamInvInqReferralById(referralId))
    .done(function(lookups, examIdentifiers, referral) {
      NavUtils.navigate('#sec/exam/' + examId + '/referral/' + referralId + '/edit');
      Scaffold.content.show(
        new SecExamInvInqReferralEditView({
          model: new Backbone.Model({
            examInvInqReferralOptions: lookups.examInvInqReferralOptions,
            examIdentifiers: examIdentifiers,
            objectTypeId: 'EXAM',
            objectId: examId,
            referralId: referralId,
            referral: referral,
            isExam: true
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
